import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {Store} from '@ngrx/store';
import {UrlService} from '@app/services/url.service';
import {Meta, Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {SeoContent} from '@app/marketplace/seo-content/seo-content';
import * as selectors from '@app/marketplace/stores/state/store-details/store-details-selectors';
import * as actions from '@app/marketplace/stores/state/store-details/store-details-actions';
import {isPlatformBrowser} from '@angular/common';
import * as locationSelectors from '@app/marketplace/locations/state/locations-selectors';
import {filter} from 'rxjs/operators';
import {MarketStoreDetails} from '@app/marketplace/stores/_models/store.interface';
import {PushToCartComponent} from '@app/marketplace/shared/_components/push-cart.component';
import { ViewTypeEnum } from '@app/marketplace/core/enum/viewTypeEnum';
declare const $: any;

@Component({
  selector: 'app-store-details',
  templateUrl: './store-details.component.html',
  styleUrls: ['./store-details.component.css']
})
export class StoreDetailsComponent extends PushToCartComponent implements OnInit, OnDestroy {
  payload: any;
  data$: Observable<MarketStoreDetails>;
  isLoading$: Observable<any>;
  theme = {'min-width': '273px', 'min-height': '151px', background: '#f1f1f1'};
  protected _subscriptions: Subscription[] = [];

  constructor(private store: Store<any>,
              private urlService: UrlService,
              private metaService: Meta,
              private titleService: Title,
              private route: ActivatedRoute,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId) {
    super(route, metaService, titleService, router);
    this.data$ = this.store.select(selectors.selectResponse);
    this.isLoading$ = this.store.select(selectors.selectLoading);
  }

  ngOnInit(): void {
    this.title = 'Cubatel Market | Tu tienda de envíos a Cuba';
    this.description = '¡Somos el Amazon cubano! Descubre nuestras tiendas online para comprar en Cuba desde el exterior. Entregamos a domicilio en todas las provincias cubanas.';
    this.keywords = 'tiendas online para envíos a cuba, amazon cubano, amazon en cuba, tiendas de envíos a cuba, tienda de envíos a cuba, envío a cuba online, tiendas online con envío a cuba, compras online en cuba desde el exterior, tiendas online en cuba para comprar desde el exterior, tiendas de envíos a cuba online, tiendas virtuales en cuba para comprar desde el exterior, compras online para cuba desde el exterior, tiendas online para comprar en cuba desde el exterior, compras desde el exterior para cuba';
    this.h1 = '';
    this.loadPrerender();
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      this._subscriptions.push(this.store.select(locationSelectors.selectLocation).pipe(filter(res => res.isSuccess)).subscribe(() => {
        this.store.dispatch(actions.LoadingStoreDetailsActions());
      }));
    }
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }

  showActive(id: any, count) {
    let i = count;
    while (i > 0) {
      i -= 1;
      $(`#previewImg${i}`).removeClass('fade show active');
    }
    $(`#previewImg${id}`).addClass('fade show active');
  }

  cancelRequest = () => this.store.dispatch(actions.CancelRequestStoreDetailsActions());

  public pushToCart(product: any) {
    const itemImg = $(`#${product.code}`).find('img').eq(0);
    this.flyToElement($(itemImg), product,ViewTypeEnum.StoreDetails, this.store);
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(x => x.unsubscribe());
    this.cancelRequest();
  }

}
